<template>
    <transition name="fade">
        <div class="patient-coaching-summary-mindset">
            <b-row :cols="cols" class="px-3" :class="$utils.themeIs('shs') ? 'justify-content-around' : ''">
                <template v-if="$utils.themeIs('wellcoaches')">
                    <b-col class="text-center">
                        <label>{{ $i18n.gt('HEADING_REPORT_RATIO') }}</label>
                        <div class="ratio-value">
                            {{ ratioScore }}
                        </div>
                    </b-col>
                    <b-col>
                        <patient-coaching-summary-wbi/>
                    </b-col>
                </template>
                <b-col>
                    <patient-coaching-summary-rtc/>
                </b-col>
                <b-col>
                    <patient-coaching-summary-notes v-show="viewNotes"/>
                </b-col>
            </b-row>

            <!--            <b-row v-for="(g, index) in goals" :key="index">-->
            <!--                <b-col cols="3" class="text-center">-->
            <!--                    <label>{{ g.timeframe }}</label>-->
            <!--                </b-col>-->
            <!--                <b-col cols="1" class="pb-2"-->
            <!--                       v-if="showEditLinks">-->
            <!--                    <my-goals-edit-modal :goals="goals"-->
            <!--                                         :goal="g"-->
            <!--                                         :index="index">-->
            <!--                    </my-goals-edit-modal>-->
            <!--                </b-col>-->
            <!--                <b-col :cols="showEditLinks ? 7 : 8" class="pb-2">-->
            <!--                    {{ g.goal }}-->
            <!--                </b-col>-->
            <!--            </b-row>-->

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummaryMindset',
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        viewNotes() {
            return this.participant.wellness_plan.mindsetNotes && this.participant.wellness_plan.mindsetNotes.allowProviderView
        },
        cols() {
            if (this.$mq == 'sm') {
                return 1
            } else {
                return this.viewNotes ? 3 : 2
            }
        },
        ratioScore() {
            const scoreDef = this.participant.latestScoreDefs['RATIO_SCORE']
            if (scoreDef && scoreDef.score.score) { // between 0 and 1
                return Math.round(10 * scoreDef.score.score) + ':1'
            } else {
                return null
            }
        },
        // goals() {
        //     return this.participant.wellness_plan ? this.participant.wellness_plan.goals : []
        // },
        modalId() {
            return `modal_rtc`
        },
    }
})
</script>

<style lang="scss">

.patient-coaching-summary-mindset {
    // see also MyMindset
    .ratio-value {
        width: 100%;
        text-align: center;
        font-size: 1.5em;
    }
}

</style>


